import { GithubIcon,LinkedinIcon } from '../assets/svg/index'

  const  contactData = [
    {
      icon:<LinkedinIcon/>,
      Title:'My Linked In Profile',
      Description:'You can Visit My Linked In Profile Here',
      url:"https://www.linkedin.com/in/rigeljohnjamon"
    },
    {
        icon:<GithubIcon/>,
        Title:'My Github Profile',
        Description:'You can Visit My Github Profile Here',
        url:"https://github.com/rigeljohn" 
      },
  ];
  
  export default contactData;